import Image from 'next/image'

import logo from '../../../../../../public/logos/glammatic/black.png'

type GlammaticLogoProps = {
  width: number
  priority?: boolean
}

export default function GlammaticLogo({ width, priority = false }: GlammaticLogoProps) {
  const height = Math.round((logo.height * width) / logo.width)

  return (
    <Image
      src={logo}
      alt="Glammatic logo"
      width={width}
      height={height}
      priority={priority}
      sizes={`${width}px`}
      className="object-contain"
    />
  )
}
